import React, { useState, useEffect } from "react";
import { AddSlabIcon } from "../../../utility/constants/assetsManager";
import {
  colorLightGrey,
  colorWhite,
  secondaryColor,
} from "../../../utility/constants/colorManager";
import {
  PERCENTAGE,
  RUPEES,
  RUPEES_SYMBOL,
} from "../../../utility/constants/valueConstants";
import { CustomInput } from "../main_comps/custom_input/CustomInput";
import "./index.css";
import SlabContainerComp from "./SlabContainerComp";
import "../../../scrollStyles.css";
import { useSnackbar } from "notistack";

export const Divider = ({ style }) => {
  return (
    <div
      style={{
        backgroundColor: "#D9D9D9",
        height: 80,
        width: 1,
        ...style,
      }}
    ></div>
  );
};
const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

const FlatContainer = ({
  onChange,
  rate,
  disabled = false,
  isEditClicked,
  clientRateEmpty,
  isValuesAdded,
  empty,
  settlementRate,
  slabAmount,
}) => {
  const [amount, setAmount] = useState("");
  const [value, setValue] = useState(RUPEES);
  useEffect(() => {
    if (empty === undefined || empty === "slab") {
      setAmount("");
      setValue(RUPEES);
    }
  }, [empty]);

  useEffect(() => {
    if (isValuesAdded) {
      setAmount("");
    }
  }, [isValuesAdded]);

  const onChangeValues = (amount, value) => {
    onChange(amount, value);
  };

  useEffect(() => {
    if (rate?.length > 0) {
      setAmount(rate[0]?.value);
      setValue(rate[0]?.type);
    }
  }, [rate]);

  useEffect(() => {
    if (
      settlementRate &&
      settlementRate?.comissionRate?.length > 0 &&
      settlementRate.comissionType?.toLowerCase() === "flat"
    ) {
      setAmount(settlementRate.comissionRate[0]?.value);
      setValue(settlementRate.comissionRate[0]?.type);
    }
    if (
      settlementRate &&
      settlementRate?.comissionRate?.length > 0 &&
      settlementRate.comissionType?.toLowerCase() === "slab"
    ) {
     
      setAmount(slabAmount);
    }
  }, [settlementRate]);

  useEffect(() => {
    if (!isEditClicked && rate?.length > 0) {
      setAmount(rate[0]?.value);
      setValue(rate[0]?.type);
    }
  }, [!isEditClicked, rate]);

  useEffect(() => {
    if (clientRateEmpty) {
      setAmount("");
    }
  }, [clientRateEmpty]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
      }}
    >
      <CustomInput
        disabled={disabled}
        type="select"
        options={[
          {
            label: `${RUPEES_SYMBOL}`,
            value: RUPEES,
          },
          {
            label: `%`,
            value: PERCENTAGE,
          },
        ]}
        value={value}
        inputStyles={{
          width: 70,
          minWidth: 0,
          border: "1px solid #CBCBCB",
        }}
        containerStyles={{
          width: 70,
          border: "1px solid #CBCBCB",
        }}
        onChange={(val) => {
          setValue(val);
          onChangeValues(amount, val);
        }}
      />
      <CustomInput
        disabled={disabled}
        value={amount || slabAmount || ""}
        onChange={(data) => {
          setAmount(data);
          onChangeValues(data, value);
        }}
        inputcomponentStyles={{ ...styles.inputStyle }}
        placeholder=""
        validator={value === RUPEES ? "paise" : "percentageDecimal"}
        type="input"
        inputStyles={{
          ...styles.containerStyle,
        }}
      />
    </div>
  );
};

const SlabContainer = ({
  onChangeTexts,
  isValuesAdded,
  disabled = false,
  settlementRate,
  empty,
}) => {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [amount, setAmount] = useState("");
  const [value, setValue] = useState(RUPEES);

  useEffect(() => {
    if (empty === undefined) {
      setFrom("");
      setTo("");
      setAmount("");
      setValue(RUPEES);
    }
  }, [empty]);

  useEffect(() => {
    if (isValuesAdded) {
      setFrom("");
      setTo("");
      setAmount("");
      setValue("");
    }
  }, [isValuesAdded]);

  const onChangeValues = (amount, value, from, to) => {
    onChangeTexts(amount, value, from, to);
  };

  useEffect(() => {
    if (
      settlementRate &&
      settlementRate.comissionType.toLowerCase() === "slab"
    ) {
      const slabData = settlementRate.comissionRate.map((slab) => ({
        value: slab?.value || "",
        type: slab?.type || "",
        from: slab?.from || "",
        to: slab?.to || "",
      }));

      // Extract from and to values from slabData and store in arrays
      const fromValues = slabData.map((slab) => slab.from);
      const toValues = slabData.map((slab) => slab.to);
      const amountValues = slabData.map((slab) => slab.value);
      const valueValues = slabData.map((slab) => slab.type);

      // Set from, to, amount, and value states with extracted values
      setFrom(fromValues);
      setTo(toValues);
      setAmount(amountValues);
      setValue(valueValues);
    }
  }, [settlementRate]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #CBCBCB",
        borderRadius: 5,
        padding: "10px",
        boxSizing: "border-box",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 0.55,
          rowGap: 20,
        }}
      >
        <div>
          <p>From</p>
          <CustomInput
            disabled={disabled}
            value={from}
            onChange={(data) => {
              setFrom(data);
              onChangeValues(amount, value, data, to);
            }}
            inputcomponentStyles={{ ...styles.inputStyle }}
            placeholder=""
            validator="number"
            type="input"
            inputStyles={{
              ...styles.containerStyle,
            }}
          />
        </div>
        <div>
          <p>To</p>
          <CustomInput
            disabled={disabled}
            value={to}
            onChange={(data) => {
              setTo(data);
              onChangeValues(amount, value, from, data);
            }}
            inputcomponentStyles={{ ...styles.inputStyle }}
            placeholder=""
            validator="number"
            type="input"
            inputStyles={{
              ...styles.containerStyle,
            }}
          />
        </div>
      </div>
      <Divider
        style={{
          display: "flex",
          margin: "0px 10px",
        }}
      />
      <div
        style={{
          display: "flex",
          flex: 0.4,
          padding: "0px 10px",
        }}
      >
        <FlatContainer
          disabled={disabled}
          slabAmount={amount}
          onChange={(amount, val) => {
            setAmount(amount);
            onChangeValues(amount, val, from, to);
            setValue(val);
          }}
          isValuesAdded={isValuesAdded}
        />
      </div>
    </div>
  );
};

export const checkObjHasAllValue = (obj) => {
  if (Object.keys(obj)?.length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).every((val) => {
      return obj[val] !== "" && obj[val] !== undefined;
    });
    return val;
  }
};

export const checkAnyOneObjHasAllValue = (obj) => {
  if (Object.keys(obj)?.length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).some((val) => {
      return obj[val] !== "";
    });
    return val;
  }
};

function ComissionContainer({
  onClickNext,
  isSlabRequired = false,
  styles,
  innerStyles,
  rate,
  type,
  ex,
  disabled = false,
  isEditClicked,
  clientRateEmpty,
  onClickDelete,
  settlementData,
}) {
  const [currentValue, setCurrentValue] = useState("flat");
  const [totalCommission, setTotalCommission] = useState([]);
  const [flatComission, setFlatComission] = useState({});
  const [comissionObj, setComissionObj] = useState({});
  const [isValuesAdded, setIsValuesAdded] = useState(false);
  const [currentObject, setCurrentObject] = useState({});
  const reduxMethod = settlementData?.comissionType?.toLowerCase();

  useEffect(() => {
    // console.log(currentValue, "HEY");
    if (reduxMethod) {
      // console.log(settlementData, "DO NOT DISTURB");
      setCurrentValue(reduxMethod);
    }
  }, [reduxMethod]);

  const [empty, setEmpty] = useState("flat");
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (totalCommission.length > 0) {
      onClickNext([...totalCommission], {}, currentValue);
    }
  }, [totalCommission]);

  useEffect(() => {
    console.log("checkObjHasAllValue");
    if (checkObjHasAllValue(currentObject)) {
      onClickNext([...totalCommission, comissionObj], {}, currentValue);
    }
  }, [currentObject, currentValue, comissionObj]);

  useEffect(() => {
    console.log("flatComission");
    onClickNext([], flatComission, currentValue);
  }, [flatComission, currentValue]);

  useEffect(() => {
    if (currentValue === "flat") {
      setTotalCommission([]);
    } else {
      setFlatComission({});
      setEmpty("slab");
    }
  }, [currentValue]);

  useEffect(() => {
    if (type && type?.toLowerCase() === "flat") {
      setCurrentValue("flat");
      setFlatComission(rate[0]);
    } else if (type && type?.toLowerCase() === "slab") {
      setCurrentValue("slab");
      setTotalCommission(rate);
    }
  }, [type, rate]);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: colorLightGrey,
        boxSizing: "border-box",
        padding: 10,
        ...styles,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "15px 0px",
          ...innerStyles,
        }}
      >
        <div
          style={{
            flex: 0.55,
            display: "flex",
          }}
        >
          <RadioButton
            disabled={disabled}
            id="flat"
            name={"flat_radio" + ex}
            title="Flat"
            value="flat"
            onChange={(val) => {
              setCurrentValue(val.target.value);
            }}
            defaultChecked={currentValue === "flat"}
          />

          {isSlabRequired && (
            <RadioButton
              disabled={disabled}
              id="slab"
              name={"flat_radio" + ex}
              title="Slab"
              value="slab"
              onChange={(val) => {
                setCurrentValue(val.target.value);
              }}
              defaultChecked={currentValue === "slab"}
              style={{
                margin: "0px 10px",
              }}
            />
          )}
        </div>
        {currentValue === "flat" && (
          <Divider
            style={{
              display: "flex",
              height: 40,
              margin: "0px 10px",
            }}
          />
        )}
        {currentValue === "flat" && (
          <div
            style={{
              display: "flex",
            }}
          >
            <FlatContainer
              disabled={disabled}
              onChange={(amount, val) => {
                setFlatComission({
                  value: amount,
                  type: val,
                });
              }}
              rate={rate}
              isEditClicked={isEditClicked}
              clientRateEmpty={clientRateEmpty}
              currentValue={currentValue}
              empty={empty}
              settlementRate={settlementData}
            />
          </div>
        )}
      </div>

      {currentValue === "slab" && (
        <div
          style={{
            width: "100%",
            backgroundColor: colorWhite,
            maxHeight: 300,
            overflow: "auto",
          }}
        >
          {totalCommission &&
            totalCommission?.map((data, i) => (
              <SlabContainerComp
                from={data.from}
                to={data.to}
                value={data.value}
                type={data.type}
                id={i}
                onClickDelete={(id) => {
                  const filteredData = totalCommission.filter(
                    (val, i) => i !== id
                  );
                  onClickDelete([...filteredData]);
                  setTotalCommission([...filteredData]);
                }}
                currentValue={currentValue}
                empty={empty}
              />
            ))}
          <SlabContainer
            onChangeTexts={(amount, val, from, to) => {
              setIsValuesAdded(false);
              setComissionObj({
                value: amount,
                type: val,
                from,
                to,
              });

              if (
                checkObjHasAllValue({
                  value: amount,
                  type: val,
                  from,
                  to,
                })
              ) {
                setCurrentObject({
                  value: amount,
                  type: val,
                  from,
                  to,
                });
              }
            }}
            isValuesAdded={isValuesAdded}
            currentValue={currentValue}
            empty={empty}
            settlementRate={settlementData}
          />
        </div>
      )}

      {currentValue === "slab" && (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            margin: "10px 0px",
            width: "auto",
          }}
          onClick={() => {
            if (checkObjHasAllValue(comissionObj)) {
              setTotalCommission([...totalCommission, comissionObj]);
              setComissionObj({});
              //  onObjAdded();
              setCurrentObject({});
              setIsValuesAdded(true);
            } else {
              enqueueSnackbar("Please enter all the fields", {
                variant: "error",
              });
            }
          }}
        >
          <AddSlabIcon
            style={{
              marginRight: 15,
            }}
          />
          <p
            style={{
              color: secondaryColor,
              fontSize: 13,
            }}
          >
            Add More Slab
          </p>
        </div>
      )}
    </div>
  );
}

const styles = {
  inputStyle: {
    alignSelf: "center",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    width: "100%",
  },
  containerStyle: {
    padding: 0,
    height: 50,
    width: 60,
    height: 40,
    margin: 0,
    backgroundColor: colorWhite,
    border: "1px solid #CBCBCB",
  },
};
export default ComissionContainer;
